import { combineReducers } from 'redux';

//转换基金 参数
const pwdFlag=(state = false, action)=>{
  switch(action.type){
    case 'TRANSFORMATION_PWD':
      return action.text;
    default:
      return state;
  }
}
const shareClass=(state = '', action)=>{
  switch(action.type){
    case 'TRANSFORMATION_SHARECLASS':
      return action.text;
    default:
      return state;
  }
}
const selectVal=(state = '请选择转入基金', action)=>{
  switch(action.type){
    case 'TRANSFORMATION_SELECTVAL':
      return action.text;
    default:
      return state;
  }
}
const selectCode=(state = '', action)=>{
  switch(action.type){
    case 'TRANSFORMATION_SELECTCODE':
      return action.text;
    default:
      return state;
  }
}
const selectType=(state = '', action)=>{
  switch(action.type){
    case 'TRANSFORMATION_SELECTTYPE':
      return action.text;
    default:
      return state;
  }
}
const text=(state = '', action)=>{
  switch(action.type){
    case 'TRANSFORMATION_TEXT':
      return action.text;
    default:
      return state;
  }
}
const TransformationReducer = combineReducers({
	pwdFlag,
  shareClass,
  selectVal,
  text,
  selectCode,
  selectType
});

export default TransformationReducer;


// WEBPACK FOOTER //
// ./src/reducer/TransformationReducer.js